import React from "react";
import Typography from "@material-ui/core/Typography";
import history from "../../../history";
import Container from "@material-ui/core/Container";

function Aboutus() {
  return (
    <div className="my-20">
      <Container>
        <br />

        {/* Intro */}
        <div className="text-black font-bold text-center text-lg mt-8 mb-4">
          ouiiwe
        </div>
        <p className="text-black text-center">
          At ouiiwe, we believe shopping should feel personal, not
          transactional.
          <br />
          <br />
          We started ouiiwe to solve a problem that many of us feel but few
          platforms address — the disconnect between shoppers and the people
          behind the products they love. Today, it's harder than ever to find
          and support small, meaningful creators. Big platforms push big brands.
          Social media is noisy. And true discovery — the kind that feels real —
          gets lost in the scroll.
          <br />
          <br />
          ouiiwe brings everything into one simple, human space.
          <br />
          <br />
          We are building more than just a marketplace. We're building a
          community — a place where shoppers can explore unique products, hear
          the stories behind them, and connect directly with everyday creators.
          It's where shopping meets support, where creativity is valued, and
          where every purchase feels like a high-five to someone real.
          <br />
          <br />
          No middlemen. No big-brand algorithms. Just people, products, and
          purpose — all in one place.
          <br />
          <br />
          Whether you’re a maker or a mindful shopper, welcome to ouiiwe.
          <br />
          Let’s bring authenticity back to shopping together.
        </p>

        {/* Our name */}
        <div className="text-black font-bold text-center text-lg mt-8 mb-4">
          Our name
        </div>
        <p className="text-black text-center">
          Ouiiwe: /wewe/ <br />
          <strong>ouii</strong> – yes. <strong>We</strong> – together
          <br />
          <br />
          The name ouiiwe is inspired by the values we stand for: simplicity,
          togetherness, empowerment, and fairness. It’s fun and catchy, yet
          timeless and forward-thinking — just like the environment we’re
          building.
        </p>

        {/* Founder */}
        <div className="text-black font-bold text-center text-lg mt-8 mb-4">
          Founder – Patrick Luwemba
        </div>
        <p className="text-black text-center">
          “ouiiwe was born from a simple but powerful belief — that shopping
          should feel more human. As someone who has always valued the heart
          behind small businesses, I saw how hard it had become to find and
          support meaningful creators online. Discovery was scattered, unfair,
          and often overrun by big brands.
          <br />
          <br />
          So, I created ouiiwe, a platform built on simplicity, togetherness,
          empowerment, and fairness. The name itself, ouiiwe, reflects that
          spirit. This is more than a marketplace — it’s a space where people
          connect, stories matter, and every purchase supports someone real.”
        </p>

        {/* Call to action */}
        <div className="center-styl mt-6 text-center">
          <a href="/signup" className="underline text-lg font-bold">
            Signup
          </a>
        </div>

        <button
          onClick={() => history.push("/howitworks")}
          className="text-black underline text-lg font-bold text-center float-right mt-8"
        >
          How it works
        </button>
      </Container>
    </div>
  );
}

export default Aboutus;
